const createCachedSodiumEncryptorApi = ({ cachedSodiumEncryptor }) => {
    return {
        cachedSodiumEncryptor: {
            encryptSecretBox: cachedSodiumEncryptor.encryptSecretBox,
            decryptSecretBox: cachedSodiumEncryptor.decryptSecretBox,
            encryptBox: cachedSodiumEncryptor.encryptBox,
            decryptBox: cachedSodiumEncryptor.decryptBox,
        },
    };
};
const cachedSodiumEncryptorApiDefinition = {
    id: 'cachedSodiumEncryptorApi',
    type: 'api',
    factory: createCachedSodiumEncryptorApi,
    dependencies: ['cachedSodiumEncryptor'],
};
export default cachedSodiumEncryptorApiDefinition;
